export default "__VITE_ASSET__CL2Y_8yb__"